export class ListAwsExternalRecoveryPointsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accessEnabled",
            "baseName": "accessEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "recoveryPoints",
            "baseName": "recoveryPoints",
            "type": "Array<AwsExternalRecoveryPoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAwsExternalRecoveryPointsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
